export default function Hero() {
  return (
    <section className="relative w-full h-screen min-h-[600px] flex items-center">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20editorial%20flat%20lay%20photography%20with%20carefully%20arranged%20fashion%20accessories%20including%20leather%20sneakers%20folded%20designer%20sweatshirt%20cotton%20caps%20and%20minimal%20jewelry%20pieces%20scattered%20artistically%20on%20warm%20cream%20textured%20linen%20background%20soft%20natural%20morning%20light%20casting%20gentle%20shadows%20clean%20modern%20aesthetic%20harmonious%20organic%20composition%20no%20text%20labels&width=1920&height=1080&seq=hero-bg-home-v2&orientation=landscape"
          alt="OOPBuy Spreadsheet product tracking tools and fashion items"
          title="OOPBuy Spreadsheet - Product Tracking System"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/35"></div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between gap-10 lg:gap-16">
          <div className="flex flex-col gap-6 lg:gap-8 pt-20 lg:pt-0">
            <div className="flex items-center gap-3">
              <div className="flex -space-x-3">
                <div className="w-9 h-9 rounded-full bg-accent-300 border-2 border-white flex items-center justify-center">
                  <i className="ri-user-line text-white text-sm w-4 h-4 flex items-center justify-center"></i>
                </div>
                <div className="w-9 h-9 rounded-full bg-accent-400 border-2 border-white flex items-center justify-center">
                  <i className="ri-user-line text-white text-sm w-4 h-4 flex items-center justify-center"></i>
                </div>
                <div className="w-9 h-9 rounded-full bg-accent-500 border-2 border-white flex items-center justify-center">
                  <i className="ri-user-line text-white text-sm w-4 h-4 flex items-center justify-center"></i>
                </div>
              </div>
              <span className="text-white/90 text-sm font-medium">Trusted by 10,000+ resellers</span>
            </div>

            <h1 className="text-5xl md:text-7xl lg:text-8xl font-heading text-white leading-none drop-shadow-lg">
              <span className="font-bold block">OOPBuy</span>
              <span className="font-light italic block mt-1">Spreadsheet</span>
            </h1>

            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 bg-white text-foreground-950 px-8 py-3.5 rounded-full text-base font-semibold hover:bg-accent-100 transition-all duration-200 cursor-pointer whitespace-nowrap w-fit"
            >
              Buy It Now
              <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center"></i>
            </a>
          </div>

          <div className="lg:max-w-md lg:pb-8">
            <p className="text-white/85 text-base md:text-lg leading-relaxed">
              The ultimate product tracking spreadsheet built for modern e-commerce resellers. Streamline your sourcing workflow with automated profit calculations, intelligent supplier management, and real-time inventory tracking — all powered by the proven OOPBuy spreadsheet system trusted by thousands of sellers worldwide.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}